<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "account"
    }
</script>

<style scoped>

</style>